import { searchParams, getCacheData, storeCacheData, deleteCacheData } from "../graphDB-utils";
import { ContactModel } from "src/models/contact-models";
import StorageUtils from "./storage-utils";
import { fetchRedirectURL } from "./general-utils";


export const onitServerBaseURLWithoutRedirectURL = window.location.href.toLowerCase().indexOf("localhost") != -1 ? "http://localhost:3002/" :
    window.location.origin.toLowerCase().indexOf("192.168") != -1 ? window.location.origin.replace("3000", "3002/") :
        // window.location.href.toLowerCase().indexOf("devapp.") != -1 ? "https://api.onitnetwork.com:3000/" : "https://api.onitnetwork.com:3000/";
        window.location.href.toLowerCase().indexOf("staging.") != -1 ? "https://stagingapi.onitnetwork.com:3001/" :
            window.location.href.toLowerCase().indexOf("devapp.") != -1 ? "https://devapi.onitnetwork.com/" : "https://api.onitnetwork.com/";


export function onitServerBaseURL() {
    const redirectURL = fetchRedirectURL();
    const apiURL = redirectURL.toLowerCase().indexOf("localhost") != -1 || location.href.toLowerCase().indexOf("localhost") != -1 ?
        "http://localhost:3002/" : (redirectURL.toLowerCase().indexOf("devapp.") != -1 || location.href.toLowerCase().indexOf("devaccounts.") != -1) ?
            "https://devapi.onitnetwork.com/" : (redirectURL.toLowerCase().indexOf("staging.onitnetwork.com") != -1) ? "https://stagingapi.onitnetwork.com:3001/" : "https://api.onitnetwork.com/";

    return apiURL;
}

export async function ExecuteAPI<T>(postData: any, endPoint: string, enteredInstance?: string, requestWithoutInstance?: boolean) {
    const hash = window.location.hash;
    let instance = "";
    let user: ContactModel = JSON.parse(StorageUtils.getItem('user'));
    if ((hash && hash.length > 1) || (enteredInstance && enteredInstance.length > 0) || requestWithoutInstance) {
        if (!requestWithoutInstance)
            if (enteredInstance) {
                instance = enteredInstance;
            }
            else {
                let _hash = hash.indexOf("?") != -1 ? hash.substring(0, hash.indexOf("?")) : hash;
                if (_hash.indexOf("/") != -1) {
                    instance = _hash.substring(1, _hash.indexOf("/"));
                } else {
                    instance = _hash.substring(1);
                }
            }

        let data: any = {
            postData: JSON.stringify({ ...postData }),
            "instance": instance,
            "user": JSON.stringify(user)
        }

        let token = StorageUtils.getItem('token');
        const response = await fetch(`${onitServerBaseURL()}${endPoint}`, {
            mode: "cors",
            method: 'POST',
            headers: {
                "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
                "Accept": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: searchParams(data)
        });
        return await response.json().then((result) => result as T);
    }
}
export async function ExecuteAPIGet<T>(endPoint: string, queryString?: string) {
    let token = StorageUtils.getItem('token');
    let url = "";
    if (queryString)
        url = `${onitServerBaseURL()}${endPoint}?${queryString}`
    else
        url = `${onitServerBaseURL()}${endPoint}`
    const response = await fetch(url, {
        mode: "cors",
        method: 'GET',
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
        },
    });
    return await response.json().then((result) => result as T);
}
export async function ExecuteAPIDelete(id: string, endPoint: string) {
    let token = StorageUtils.getItem('token');
    const response = await fetch(`${onitServerBaseURL()}${endPoint}?id=${id}`, {
        mode: "cors",
        method: 'DELETE',
        headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            "Accept": "application/json",
            "Authorization": `Bearer ${token}`
        }
    });
    return await response.json().then((result) => result);
}
export async function ExecuteAPI_Updates<T>(postData: any, endPoint: string, entity: string) {
    const response = await ExecuteAPI<T>(postData, endPoint);

    return response;
}

export async function ExecuteAPI_Select<T>(postData: any, endPoint: string, entity?: string, noCache?: boolean, requestWithoutInstance?: boolean, enteredInstance?: string) {
    let resData: T;
    if (entity && !noCache)
        resData = getCacheData<T>(JSON.stringify({ postData, endPoint }), entity);

    if (resData)
        return resData
    else {
        const response: any = await ExecuteAPI<T>(postData, endPoint, enteredInstance, requestWithoutInstance);
        storeCacheData(JSON.stringify({ postData, endPoint }), response, entity);
        if ((response && !response.success) && response.message && (response.message == 'Token is not valid' ||
            response.message == 'Auth token is not supplied' || response.message == 'Please provider user')) {
            StorageUtils.clear();
            //window.location.reload();
        }
        else if ((response && !response.success) && response.message && response.message == 'OTP not verified') {
            if (StorageUtils.getItem('verifyOTP') == null) {
                StorageUtils.clear();
            }
            else {
                StorageUtils.setItem("verifyOTP", "1");
            }
            //window.location.reload();
        }

        return response as T;
    }
}

export async function ExecuteAPI_Update<T>(postData: any, endPoint: string, entity: string, instance?: string) {
    const response = await ExecuteAPI<T>(postData, endPoint, instance);

    deleteCacheData(entity);
    return response;
}

export const API_EndPoints = {
    DELETEALLRELEVANTDATA: "DeleteAllRelevantData",
    GetSubClassOf: "GetSubClassOf",
    GetRdfsLabel: "GetRdfsLabel",
    IsOntologyExist: "IsOntologyExist",
    GetRelatedList: "GetRelatedList",
    ReloadRepoUrls: "ReloadRepoUrls",
    GetInstanceList: "GetInstanceList",
    BUILDINGS: {
        GETBUILDINGS: "Buildings",
        SAVEBUILDING: "Buildings/Save",
        DELETEBUILDING: "Buildings/Delete",
    },
    ALARMS: {
        GetCutomerAlarm: "FetchCustomerAlarm",
        GetSupervisorAlarm: "FetchSupervisoryAlarm",
        DeleteCustomerAlarm: "DeleteCustomerAlarm",
        DeleteSupervisorAlarm: "DeleteSupervisoryAlarm",
        UpdateCustomerAlarm: "UpdateCustomerAlarm",
        UpdateSuperviorAlarm: "UpdateSupervisoryAlarm"
    },
    ZONES: {
        GETZONES: "Zones",
        GETFLOORLIST: "Zones/GetFloorList",
        SAVEZONE: "Zones/Save",
        SAVEFLOOR: "Zones/SaveFloor",
        DELETEZONE: "Zones/Delete",
        GETSERVICEPROVIDERSLIST: "Zones/GetServiceProvidersList",
        GetAllZonesList: "Zones/GetAllZonesList",
        GetZoneTypesList: "Zones/GetZoneTypesList"
    },
    SPACES: {
        GETSPACES: "Spaces",
        GetLocationsList: "Spaces/GetLocationsList",
        getLocationsListSpacesByZones: "Spaces/getLocationsListSpacesByZones",
        GetAllLocationsList: "Spaces/GetAllLocationsList",
        SAVESPACE: "Spaces/Save",
        DELETESPACE: "Spaces/Delete",
        GetSpaceTypesList: "Spaces/GetSpaceTypesList",
        GetSpaceEquipmentList: "Spaces/GetSpaceEquipmentList",


    },
    WALKTHROUGH: {
        GetWorkFlow: "GetWorkFlow",
        GetWorkFlowDescription: "GetWorkFlowDescription",
        GetWorkFlowSpaceList: "GetWorkFlowSpaceList",
        SaveWorkFlow: "Inspections/SaveWorkFlow",
        DeleteWorkFlow: "Inspections/DeleteWorkFlow",
        GetContactAccessRight: "Inspections/GetContactAccessRight",
        DeleteContactAccessRight: "Inspections/DeleteContactAccessRight",
    },
    LIFE: {
        SaveProject: "Life/SaveProject"
    },
    Alarms: {
        GetAlarmsList: "GetAlarmsList",
        DeleteAlarm: "Alarm/DeleteAlarm"
    },
    Stripe: {
        PaymentMethod: "Stripe/PaymentMethod",
        StripeCustomer: "Stripe/Customer",
        StripeSubscription: "Stripe/Subscription",
        GetPaymentMethod: "Stripe/GetPaymentMethod",
        DeletePaymentMethod: "Stripe/DeletePaymentMethod",
        StripeCreateInvoice: "Stripe/CreateInvioce"
    },

    SpreadSheet: {
        FetchSpreadSheet: "SpreadSheet/GetSheetData",
        SetSpreadSheet: "SpreadSheet/SetSheetData",
    },

    Calendar: {
        GetEvent: "Calendar/GetEvent",
        SetEvent: "Calendar/SetEvent",
        DeleteEvent: "Calendar/DeleteEvent"
    },
    EQUIPMENT: {
        SaveEquipment: "Equipments/Save",
        SaveComponent: "Equipments/SaveComponent",
        GetHeatingTypeList: "Equipments/GetHeatingTypeList",
        SaveLightingInformation: "Equipments/SaveLightingInformation",
        SavePlugLoadModel: "Equipments/SavePlugLoadModel",
        FetchEquipments: "Equipments/FetchEquipments",
        GetEquipmentDetails: "Equipments/GetEquipmentDetails",
        GetAllCoolingAndHeatingEquipmentsList: "Equipments/GetAllCoolingAndHeatingEquipmentsList",
        GetAllEquipmentExceptCoolingAndHeatingList: "Equipments/GetAllEquipmentExceptCoolingAndHeatingList",
        GetAllEquipmentsList: "Equipments/GetAllEquipmentsList",
        GetEquipmentTypeList: "Equipments/GetEquipmentTypeList",
        GetSubClassTypeListForEquipment: "Equipments/GetSubClassTypeListForEquipment",
        GetSubClassTypeList: "Equipments/GetSubClassTypeList",
        GetComponentTypesList: "Equipments/GetComponentTypesList",
        FetchEquipmentExportData: "Equipments/FetchEquipmentExportData",
        GetFuelTypeList: "Equipments/GetFuelTypeList",
        GetComponents: "Equipments/GetComponents",
        GetFixtures: "Equipments/GetFixtures",
        GetTypeByEquipmentName: "Equipments/GetTypeByEquipmentName",
        FetchPowerSource: "Equipments/FetchPowerSource",
        FetchPlugLoad: "Equipments/FetchPlugLoad",


    },
    ASSETS: {
        GetAssetBIM: "Assets/GetAssetBIM",
        GetAssets: "Assets/GetAssets",
        GetDeviceAssets: "Assets/GetDeviceAssets",
        SaveECM: "Assets/SaveECM",
        GetECM: "Assets/GetECM",
        GetECM_Notes: "Assets/GetECM_Notes",
        SavePreRCX: "Assets/SavePreRCX",
        SavePostRCX: "Assets/SavePostRCX",
        GetPreRCX: "Assets/GetPreRCX",
        GetPostRCX: "Assets/GetPostRCX",
        SaveCA: "Assets/SaveCA",
        GetCA: "Assets/GetCA",
        GetInspection_IsComplete: "Assets/GetInspection_IsComplete",
        DoCompleteInspection: "Assets/DoCompleteInspection",
        UncompleteInspection: "Assets/UncompleteInspection"
    },
    VENDORS: {
        GETVENDORS: "Vendors",
        SAVEVENDORS: "Vendors/Save",
        DELETEVENDORS: "Vendors/Delete",
        GetShipToItems: "Vendors/GetShipToItems"
    },
    DOCUMENTS: {
        SaveDocument: "Documents/SaveDocument",
        GetDocuments: "Documents/GetDocuments",
        SaveCommunityDoc: "Documents/SaveCommunityDoc",
        GetCommunityDocs: "Documents/GetCommunityDocs",
        GetDocumentFilesList: "Documents/GetDocumentFilesList"
    },
    SUPPLY: {
        SaveSupplyChain: "Supply/SaveSupplyChain",
        GetSupplyChains: "Supply/GetSupplyChains",
        DeleteSupplyChain: "Supply/DeleteSupplyChain"
    },
    CONTACT: {
        CheckSession: "Contacts/CheckSession",
        FetchPeople: "Contacts/FetchPeople",
        FetchGuestUser: "Contacts/FetchGuestUser",
        FetchSingleUser: "Contacts/FetchSingleUser",
        FetchContactGroupList: "Contacts/FetchContactGroupList",
        InsertContact: "Contacts/InsertContact",
        InsertGuestUser: "Contacts/InsertGuestUser",
        ChangePassword: "Contacts/ChangePassword",
        ChangePasswordFromAccounts: "Contacts/ChangePasswordFromAccounts",
        ChangePasswordEmail: "Contacts/ChangePasswordEmail",
        FetchQualificationsList: "Contacts/FetchQualificationsList",
        DeleteContact: "Contacts/DeleteContact",
        UnsubscribeContactSMSAlerts: "Contacts/UnsubscribeContactSMSAlerts",
        InsertTenant: "Contacts/InsertTenant",
        SaveSpaceTenant: "Contacts/SaveSpaceTenant",
        FetchTenantList: "Contacts/FetchTenantList",
        FetchSpaceTenantList: "Contacts/FetchSpaceTenantList",
        FetchSpaceTenantInfo: "Contacts/FetchSpaceTenantInfo",
        FetchOtherContacts: "Contacts/FetchOtherContacts",
        DeleteTenant: "Contacts/DeleteTenant",
        DeleteSpaceTenant: "Contacts/DeleteSpaceTenant",
        UpdateSpaceTenant: "Contacts/UpdateSpaceTenant",
        GetZoneTenantsList: "Contacts/GetZoneTenantsList",
        AuthenticateUser: "Contacts/AuthenticateUser",
        VerifyOTP: "Contacts/VerifyOTP",
        ResendOTP: "Contacts/ResendOTP",
        Token: "Token",
        UpdateUserStatus: "Contacts/UpdateUserStatus",
        SendEmailForgetPassword: "Contacts/SendEmailForgetPassword",
        GetEmailNotification: "Contacts/GetEmailNotification",
        AuthenticateUserForApp: "Contacts/AuthenticateUserForApp",
        CheckUserExists_Mongo: "User/CheckUserExistsM",
        AddInstanceInfo_Mongo: "User/AddInstanceInfoM",
        CheckInstanceExists_Mongo: "CheckInstanceExistsM"
    },
    PURCHASEORDER: {
        SavePurchaseOrder: "PurchaseOrders/SavePurchaseOrder",
        DeletePO_Items: "PurchaseOrders/DeletePO_Items",
        FetchPurchaseOrders: "PurchaseOrders/FetchPurchaseOrders",
        FetchPurchaseOrderItems: "PurchaseOrders/FetchPurchaseOrderItems",
        SetNewStatusPO: "PurchaseOrders/SetNewStatusPO",
        GetWorkOrdersList: "PurchaseOrders/GetWorkOrdersList"
    },
    WORKORDER: {
        FetchWorkOrders: "WorkOrders/FetchWorkOrders",
        SetNewStatus: "WorkOrders/SetNewStatus",
        ArchiveWorkOrder: "WorkOrders/ArchiveWorkOrder",
        SaveWorkOrder: "WorkOrders/SaveWorkOrder"
    },
    CHATS: {
        GetChats: "Chats/GetChats",
        ArchiveChat: "Chats/ArchiveChat",
        DeleteChat: "Chats/DeleteChat",
    },
    SEARCH: {
        GetSearchResults: "Search/GetSearchResults"
    },
    TASKS: {
        GETTASKS: "Tasks",
        GetWorkTypeList: "Tasks/GetWorkTypeList",
        GetTaskTypeList: "Tasks/GetTaskTypeList",
        GetSubTask: "Tasks/GetSubTask",
        UpdateSubTask: "Tasks/UpdateSubTask",
        UpdateRootTask: "Tasks/Save",
        DeleteRootTask: "Tasks/DeleteRootTask",
        UpdateRootTaskDeleteStatus: "Tasks/UpdateRootTaskDeleteStatus",
        DeleteSubTask: "Tasks/DeleteSubTask",
        ArchiveTask: "Tasks/ArchiveTask",
        AddPauseNote: "Tasks/AddPauseNote",
        DeletePauseNote: "Tasks/DeletePauseNote",
        AddNote: "Tasks/AddNote",
        DeleteNote: "Tasks/DeleteNote",
        AcknowledgeRootTask: "Tasks/AcknowledgeRootTask",
        UpdateTaskStatus: "Tasks/UpdateTaskStatus",
        DeleteTaskStartTime: "Tasks/DeleteTaskStartTime",
        UpdateTaskStartTime: "Tasks/UpdateTaskStartTime",
        UpdateLastMessageOn: "Tasks/UpdateLastMessageOn",
        UpdateUnreadCount: "Tasks/UpdateUnreadCount",

    },
    DEVICES: {
        GETDEVICES: "Devices",
        GETDEVICEDETAIL: "Devices/Detail",
        GETDEVICETYPELIST: "Devices/GetDeviceTypeList",
        SaveEquipmentType: "Devices/SaveEquipmentType",
        UPDATEDEVICE: "Devices/Save",
        CheckDeviceID: "Devices/CheckDeviceID",
        FetchInsights: "Devices/FetchThermostats",
        FetchInsights_Export: "Devices/FetchThermostats_Export",
        FetchInsightNamePlate: "Devices/FetchThermostatNamePlate",
        FetchInsightExportData: "Devices/FetchThermostatExportData",
        FetchInsightInfo: "Devices/FetchThermostatInfo",
        PostInsightChanges: "Devices/PostThermostatChanges",
        FetchIntesisInfo: "Devices/FetchIntesisInfo",
        PostIntesisChanges: "Devices/PostIntesisChanges",
        SaveSchedule: "Devices/SaveSchedule",
        SaveADP: "Devices/SaveADP"
    },
    POINTS: {
        GETPOINTS: "Points",
        GetPointDetails: "Points/GetPointDetails",
        CheckPointId: "Points/CheckPointId",
        GETPOINTTYPES: "Points/GetPointTypes",
        GETPOINTFUNCTION: "Points/GetPointFunction",
        GETPLANNEDPOINTS: "Points/Planned",
        UPDATEPOINT: "Points/Save",
        ADDNEWPOINTFUNCTION: "Points/AddNewPointFunction",
        ADDNEWPOINTTYPE: "Points/AddNewPointType",

    },
    PRICING: {
        SavePricePackage: "Pricing/SavePricePackage",
        GetPricePackages: "PricePackages",
        DeletePricePackage: "Pricing/DeletePricePackage",
        // StripeSavePricePackage: "Pricing/StripeSavePricePackage",

    },
    EMAIL: {
        SendEmail: "SendEmail",

    },
}




// WEBPACK FOOTER //
// ./src/server/utils/onit-server-utils.ts